class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '7c16a4fd';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1125.0.3';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Mon, 08 Sep 2025 15:36:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2025-09-08 11:36:16 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2025-09-08 11:36:16 Boston - 7c16a4fd - 1125.0.3';
export default BuildTags;
